export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70fd9837e7526e85648a3a4363a841c4d1f44b0d0f&name=pushAdClickData!'